import baseUrl from '../../../utils/baseUrl';
import getToken from '../../../utils/getToken';

export default async function DeletePhotoCard(photoCardId) {
  return fetch(`${baseUrl()}/api/v1/photo_cards/${photoCardId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    }
  });
}
